import template from 'text!./policy-contacts-summary.html';
import controller from './PolicyContactsSummaryTable';

/**
 * @ngdoc component
 * @name edge.gateway.contacts.common.app.component: gwPolicyContactsSummaryTable
 *
 * @description  A component to display the contacts on a policy.
 *
 * @param policyNumber {string} the policy number for the policy
 * @param pageSize: {number} the page size used for pagination.
 * @param onInitialLoad {expression} an expression to be evaluated when the contacts are first loaded,
 * 'totalContactCount' gives access to the total number of contacts on this policy.
 */
export default {
    controller,
    template: template,
    bindings: {
        policyNumber: '<',
        onInitialLoad: '&',
        pageSize: '<'
    }
};